import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-kann-base">
        <Loader2 className="w-8 h-8 text-kann-gold animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
